import React, { useEffect, useState, useRef } from "react";
import Select from "react-select";
//import ImageWithBasePath from "../../img/imagewithbasepath"; // Corrected the import path typo
// import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import countriesData from '../../json/countries.json'; 
import { set_page_refresh } from "../../redux/action";
// import PropTypes from "prop-types"; 
import { addPublicUser } from "../../../api/settings.ts";

const AddCustomerModal = () => {//{countries}
  const dispatch = useDispatch();
  
  const l = useSelector((state) => state.language || "en");
  const t = useSelector((state) => state.translation || "en");
  const choose = t?.[l]?.["choose"] || "Choose";
  const [customer, setCustomer] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    password: "",
    notes: "",
    
    shippingAddress: {
      city: "",
      state: "",
      zipCode: "",
      address: "",
      country: ""
    },
  });
  const closeRef = useRef(null);
  const closeRef2 = useRef(null);
  const countriesOptions = countriesData;
  // const countriesOptions = countries.map((country) => ({
  //   label: t[l]?.[country.id] || country.id,
  //   value: country.id,
  // }));

  useEffect(() => {
    const handleHidden = () => {
      setCustomer({
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        password: "",
        notes: "",
        
        shippingAddress: {
          city: "",
          state: "",
          zipCode: "",
          address: "",
          country: ""
        },
      });
    };

    const modalElement = document.getElementById("add-units");
    modalElement?.addEventListener("hidden.bs.modal", handleHidden);

    return () => {
      modalElement?.removeEventListener("hidden.bs.modal", handleHidden);
    };
  }, []);


  const submit = async (event) => {
    const form = event.currentTarget;

    event.preventDefault();
    event.stopPropagation();

    try {
      if (form?.checkValidity()) {
    console.log("customer", customer);              
        let result = await addPublicUser(customer);
        document.querySelector(".modal-backdrop").classList.toggle("show");
        dispatch(set_page_refresh("suppliers"));
        setCustomer({ });
        form.reset();
        closeRef.current?.click();
        closeRef2.current?.click();
        console.log(result);
      } else {
        return false;
      }
    } catch (e) {
      console.log(e);
      return false;
    }

    return true;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (["city", "state", "zipCode", "address", "country"].includes(name)) {
      setCustomer((prevState) => ({
        ...prevState,
        shippingAddress: {
          ...prevState.shippingAddress,
          [name]: value,
        },
      }));
    } else {
      setCustomer((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  return (
    <div>
      {/* Add Customer */}
      <div className="modal fade" id="add-units">
        <div className="modal-dialog modal-lg modal-dialog-centered custom-modal-two">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>{t?.[l]?.["add_customer"] || "Add Customer"}</h4>
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    ref={closeRef}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body">
                  <form onSubmit={submit}>
                    <div className="row">
                      <div className="col-lg-12 hidden">
                        <div className="new-employee-field">
                          <span>Avatar</span>
                          <div className="profile-pic-upload mb-2">
                            <div className="profile-pic">
                              <span>
                                <i
                                  data-feather="plus-circle"
                                  className="plus-down-add"
                                />{" "}
                                Profile Photo
                              </span>
                            </div>
                            <div className="input-blocks mb-0">
                              <div className="image-upload mb-0">
                                <input type="file" />
                                <div className="image-uploads">
                                  <h4>Change Image</h4>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="input-blocks">
                          <label>{t?.[l]?.["first_name"] || "First Name"}</label>
                          <input
                            type="text"
                            className="form-control"
                            required
                            name="firstName"
                            value={customer.firstName || ""}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="input-blocks">
                          <label>{t?.[l]?.["last_name"] || "Last Name"}</label>
                          <input
                            type="text"
                            className="form-control"
                            required
                            name="lastName"
                            value={customer.lastName || ""}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                        <div className="col-lg-4">
                        <div className="input-blocks">
                          <label>{t?.[l]?.["phone"] || "Phone"}</label>
                          <input
                            type="text"
                            className="form-control"
                            onInput={(e) => {
                              e.target.value = e.target.value.replace(/\D/g, "");
                            }}
                            maxLength={15}
                            required
                            name="phoneNumber"
                            value={customer.phoneNumber || ""}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="input-blocks">
                          <label>{t?.[l]?.["email"] || "Email"}</label>
                          <input
                            type="email"
                            className="form-control"
                            required
                            name="email"
                            value={customer.email || ""}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="input-blocks">
                          <label>{t?.[l]?.["password"] || "Password"}</label>
                          <input
                            type="password"
                            className="form-control"
                            maxLength={15}
                            required
                            name="password"
                            value={customer.password || ""}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <hr />
               
                     
                      <div className="col-lg-6 col-sm-10 col-10">
                        <div className="input-blocks">
                          <label>{t?.[l]?.["country"] || "Country"} *</label>
                          <Select
                            className="select"
                            options={countriesOptions}
                            name="country"
                            placeholder={choose}
                            required
                            value={countriesOptions.find(option => option.value === customer?.shippingAddress?.country)}
                            onChange={(v) => {
                              handleInputChange({ target: { name: "country", value: v.value } });
                            }}
                          />
                        </div>
                      </div>
                       <div className="col-lg-6 col-sm-10 col-10">
                        <div className="input-blocks">
                          <label>{t?.[l]?.["city"] || "City"} </label>
                          <input
                            type="text"
                            name="city"
                            required
                            value={customer?.shippingAddress?.city || ""}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-10 col-10">
                        <div className="input-blocks">
                          <label>{t?.[l]?.["state"] || "State"}</label>
                          <input
                            type="text"
                            name="state"
                            value={customer?.shippingAddress?.state || ""}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>

                      <div className="col-lg-6 col-sm-10 col-10">
                        <div className="input-blocks">
                          <label>{t?.[l]?.["zip"] || "Zip"}</label>
                          <input
                            type="text"
                            name="zipCode"
                            value={customer?.shippingAddress?.zipCode || ""}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>


                      <div className="col-lg-12">
                        <div className="input-blocks">
                          <label>{t?.[l]?.["address"] || "Address"}</label>
                          <input
                            type="text"
                            className="form-control"
                            name="address"
                            required
                            value={customer.shippingAddress?.address || ""}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="input-blocks">
                          <label>{t?.[l]?.["notes"] || "Notes"}</label>
                          <input
                            type="text"
                            className="form-control"
                            name="notes"
                            value={customer.notes || ""}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                     
                    </div>
                    <div className="modal-footer-btn">
                      <button
                        type="button"
                        className="btn btn-cancel me-2"
                        data-bs-dismiss="modal"
                      >
                        {t?.[l]?.["cancel"] || "Cancel"}
                      </button>
                      <button type="submit" className="btn btn-submit">
                        {t?.[l]?.["save"] || "Save"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Customer */}
    </div>
  );
};
// AddCustomerModal.propTypes = {
//     countries: PropTypes.array,
//   };
export default AddCustomerModal;
